import { configureStore } from '@reduxjs/toolkit';
import desconexionReducer from './desconexion/desconexion';

const store = configureStore({
  reducer: {
    desconexion: desconexionReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
